import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProfileAvatar from "@Shared/components/general/profile-avatar";
import BoardsDropdown from "@Broker/@Modules/clients/board/client-profile/components/boards-dropdown";
import moment from "moment";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { Event } from "@alexrafael10/vue-tables-2";
import { UPDATE_BOARD_CLIENTS, TRANSFER_CLIENT_PROFILE } from "@Broker/@Modules/clients/board/store/board-actions";
import { mapActions } from "vuex";
import { showToast } from "@Shared/@Utils/constants";
import InactiveClientsFilterDropdown from "./inactive-clients-filter-dropdown";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "InactiveTable",
  components: {
    ProfileAvatar,
    BoardsDropdown,
    SimpleButton,
    InactiveClientsFilterDropdown
  },
  props: {
    tableName: {
      type: String,
      required: true
    },
    clients: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      columns: ["fullName", "referrer", "createdAt", "updatedAt", "board"],
      boardFilters: [],
      loadingTransfer: {}
    };
  },
  computed: {
    getClients() {
      return this.clients;
    },
    tableOptions() {
      return {
        filterable: false,
        sortable: ["fullName", "referrer", "createdAt", "updatedAt"],
        sortIcon: {
          base: "fa",
          up: "fa-sort-up",
          down: "fa-sort-down",
          is: "fa-sort"
        },
        showChildRowToggler: false,
        headings: {
          fullName: this.$t("tables.columns.name"),
          referrer: this.$t("tables.columns.referrer"),
          createdAt: this.$t("tables.columns.created"),
          updatedAt: this.$t("tables.columns.lastUpdated")
        },
        perPage: 999999,
        customSorting: {
          fullName: ascending => {
            return this.customNameSorting(ascending);
          },
          referrer: ascending => {
            return this.customRefererSorting(ascending, "referrer");
          },
          createdAt: ascending => {
            return this.customDateSorting(ascending, "created");
          },
          updatedAt: ascending => {
            return this.customDateSorting(ascending, "lastUpdated");
          }
        },
        tabbable: false,
        skin: "table table-hover",
        columnsClasses: {
          fullName: "w-30",
          referrer: "w-20",
          createdAt: "w-20",
          updatedAt: "w-20"
        },
        texts: {
          noResults: this.$t("inactive-clients.emptyInactiveClients")
        }
      };
    }
  },
  watch: {
    boardFilters(boardIds) {
      this.$emit("sort", {
        boardIds
      });
    }
  },
  mounted() {
    Event.$on("vue-tables.inactive.sorted", ({
      column,
      ascending
    }) => {
      this.$emit("sort", {
        orderBy: column,
        orderType: ascending ? "ASC" : "DESC"
      });
    });
  },
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [UPDATE_BOARD_CLIENTS, TRANSFER_CLIENT_PROFILE])), {}, {
    handleClick(id, boardId) {
      this.$emit("reactivate", {
        id,
        boardId
      });
    },
    clientProfile(clientProfileId, boardId) {
      return {
        name: "client-profile",
        params: {
          clientProfileId,
          boardId
        }
      };
    },
    customNameSorting(ascending) {
      return (a, b) => {
        const nameA = `${a.givenName || ""} ${a.familyName || ""}`.toLowerCase();
        const nameB = `${b.givenName || ""} ${b.familyName || ""}`.toLowerCase();
        return ascending ? nameA.localeCompare(nameB) : nameB.localeCompare(nameA);
      };
    },
    customDateSorting(ascending, column) {
      return (a, b) => {
        const dateA = new Date(a[column]);
        const dateB = new Date(b[column]);
        return ascending ? dateA - dateB : dateB - dateA;
      };
    },
    customRefererSorting(ascending) {
      return (a, b) => {
        const nameA = `${a.referrer.givenName || ""} ${a.referrer.familyName || ""}`.toLowerCase();
        const nameB = `${b.referrer.givenName || ""} ${b.referrer.familyName || ""}`.toLowerCase();
        return ascending ? nameA.localeCompare(nameB) : nameB.localeCompare(nameA);
      };
    },
    async transferProfile({
      id,
      boardId,
      statusLabelId,
      inactive,
      currentBoard
    }) {
      this.$set(this.loadingTransfer, id, {
        loading: true,
        succeeded: false
      });
      try {
        if (!this.inactive) {
          this.UPDATE_BOARD_CLIENTS({
            currentBoard,
            boardId
          });
        }
        await this.TRANSFER_CLIENT_PROFILE({
          id,
          statusLabelId,
          boardId,
          inactive
        });
        showToast("success", "clientProfileMoved");
        this.$set(this.loadingTransfer, id, {
          loading: false,
          succeeded: true
        });
        this.pushUp();
      } catch (error) {
        this.$set(this.loadingTransfer, id, {
          loading: false,
          succeeded: false
        });
      }
    },
    dateConverter(date) {
      return moment(date).format("MMM Do, YYYY");
    },
    pushUp() {
      this.$emit("update-board");
    },
    isTransferLoading(id) {
      var _this$loadingTransfer;
      return ((_this$loadingTransfer = this.loadingTransfer[id]) == null ? void 0 : _this$loadingTransfer.loading) || false;
    },
    transferSucceeded(id) {
      var _this$loadingTransfer2;
      return ((_this$loadingTransfer2 = this.loadingTransfer[id]) == null ? void 0 : _this$loadingTransfer2.succeeded) || false;
    }
  })
});